import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Image,
  Input,
  Radio,
  RadioGroup,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { franchiseMapIndex } from "../../../core/constants";

function PartnerReadingOrderForm({ handleSubmit, readingOrder }) {
  const [title, setTitle] = useState(readingOrder?.title);
  const [order, setOrder] = useState(readingOrder?.order);
  const [description, setDescription] = useState(
    readingOrder?.description || ""
  );
  const [fromYear, setFromYear] = useState(readingOrder?.fromYear || "");
  const [toYear, setToYear] = useState(readingOrder?.toYear || "");
  const [isOngoing, setIsOngoing] = useState(!!readingOrder?.isOngoing);
  const [franchise, setFranchise] = useState(`${readingOrder?.franchise}`);
  const [published, setPublished] = useState(
    `${readingOrder?.published ? "1" : "0"}`
  );
  const [coverImage, setCoverImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(readingOrder?.thumbnail);

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setCoverImage(file);
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit({
      title,
      description,
      franchise,
      order,
      published,
      thumbnail: coverImage,
      fromYear,
      toYear,
      isOngoing: isOngoing ? "1" : "0",
    });
  };

  return (
    <form onSubmit={onSubmit}>
      <VStack spacing={4}>
        <FormControl id="title" isRequired>
          <FormLabel>Title of your reading order</FormLabel>
          <Input
            name="title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            tabIndex={1}
          />
        </FormControl>
        <Flex alignItems="center" justifyContent="space-between" w="100%">
          <Box>
            <FormControl id="fromYear" required>
              <FormLabel>From (year)</FormLabel>
              <Input
                name="fromYear"
                type="text"
                placeholder="1961"
                value={fromYear}
                onChange={(e) => setFromYear(e.target.value)}
                tabIndex={1}
              />
            </FormControl>
          </Box>
          <Box px="3">
            <FormControl id="toYear">
              <FormLabel>To</FormLabel>
              <Input
                name="toYear"
                type="text"
                value={toYear}
                onChange={(e) => setToYear(e.target.value)}
                placeholder="Present"
                tabIndex={1}
              />
            </FormControl>
          </Box>
          <Box>
            <FormControl id="toYear">
              <FormLabel>&nbsp;</FormLabel>
              <Checkbox
                isChecked={isOngoing}
                onChange={() => setIsOngoing(!isOngoing)}
              >
                Ongoing?
              </Checkbox>
            </FormControl>
          </Box>
        </Flex>
        <FormControl id="description">
          <FormLabel>Description</FormLabel>
          <Textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            tabIndex={2}
          />
        </FormControl>
        <FormControl id="coverImage" mb={4}>
          <FormLabel>
            Cover Image (must be <code>.jpg</code>, with exact size of
            1000x640px)
          </FormLabel>
          <Input
            type="file"
            accept="image/jpeg"
            onChange={handleFileInputChange}
            tabIndex={3}
          />
          {previewUrl && (
            <Box mt={2}>
              <Image src={previewUrl} alt="Preview" maxW="500px" maxH="500px" />
            </Box>
          )}
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Franchise</FormLabel>
          <RadioGroup
            value={franchise}
            onChange={(value) => setFranchise(value)}
          >
            <HStack spacing="24px">
              {Object.keys(franchiseMapIndex).map((franchise, index) => (
                <Radio key={franchise} value={franchise} tabIndex={4}>
                  {franchiseMapIndex[franchise]}
                </Radio>
              ))}
            </HStack>
          </RadioGroup>
        </FormControl>

        <FormControl id="order">
          <FormLabel>Position in your list of reading orders</FormLabel>
          <Input
            name="order"
            type="number"
            placeholder="E.g: 3"
            value={order}
            onChange={(e) => setOrder(e.target.value)}
            required
            tabIndex={1}
          />
        </FormControl>

        {!readingOrder?.published && (
          <FormControl isRequired>
            <FormLabel>Status of publication</FormLabel>
            <RadioGroup
              value={published}
              onChange={(value) => setPublished(value)}
            >
              <HStack spacing="24px">
                <Radio value="0" tabIndex={6}>
                  Draft
                </Radio>
                <Radio value="1" tabIndex={6}>
                  Published
                </Radio>
              </HStack>
            </RadioGroup>
          </FormControl>
        )}

        <Button type="submit" colorScheme="blue" tabIndex={7}>
          {readingOrder ? "Update" : "Create"} reading order
        </Button>
      </VStack>
    </form>
  );
}

export default PartnerReadingOrderForm;
